export var NotifierMailProviderEnum;
(function (NotifierMailProviderEnum) {
    NotifierMailProviderEnum["MAIL_POST_MARK"] = "mailPostMark";
    NotifierMailProviderEnum["MAIL_MAILHOG"] = "mailMailhog";
})(NotifierMailProviderEnum || (NotifierMailProviderEnum = {}));
export var NotifierSmsProviderEnum;
(function (NotifierSmsProviderEnum) {
    NotifierSmsProviderEnum["SMS_PLIVO"] = "smsPlivo";
    NotifierSmsProviderEnum["SMS_SIMPLE_TEXTING"] = "smsSimpleTexting";
    NotifierSmsProviderEnum["SMS_NEXMO"] = "smsNexmo";
    NotifierSmsProviderEnum["SMS_GOPARROT"] = "smsGoparrot";
})(NotifierSmsProviderEnum || (NotifierSmsProviderEnum = {}));
export var NotifierPushProviderEnum;
(function (NotifierPushProviderEnum) {
    NotifierPushProviderEnum["PUSH_ONE_SIGNAL"] = "pushOneSignal";
})(NotifierPushProviderEnum || (NotifierPushProviderEnum = {}));
export var NotifierProviderTypeEnum;
(function (NotifierProviderTypeEnum) {
    NotifierProviderTypeEnum["MAIL_POST_MARK"] = "mailPostMark";
    NotifierProviderTypeEnum["MAIL_MAILHOG"] = "mailMailhog";
    NotifierProviderTypeEnum["SMS_PLIVO"] = "smsPlivo";
    NotifierProviderTypeEnum["SMS_SIMPLE_TEXTING"] = "smsSimpleTexting";
    NotifierProviderTypeEnum["SMS_NEXMO"] = "smsNexmo";
    NotifierProviderTypeEnum["SMS_GOPARROT"] = "smsGoparrot";
    NotifierProviderTypeEnum["PUSH_ONE_SIGNAL"] = "pushOneSignal";
})(NotifierProviderTypeEnum || (NotifierProviderTypeEnum = {}));
export var ConfigurationProviderEnum;
(function (ConfigurationProviderEnum) {
    ConfigurationProviderEnum["PLIVO"] = "plivo";
    ConfigurationProviderEnum["SIMPLE_TEXTING"] = "simpletexting";
    ConfigurationProviderEnum["NEXMO"] = "nexmo";
    ConfigurationProviderEnum["GOPARROT"] = "goparrot";
    ConfigurationProviderEnum["POST_MARK"] = "postmark";
    ConfigurationProviderEnum["ONE_SIGNAL"] = "onesignal";
})(ConfigurationProviderEnum || (ConfigurationProviderEnum = {}));
//# sourceMappingURL=ConfigurationProviderEnum.js.map